<template>
    <div class="InputRead">
        <span class="label_name">{{name}}:</span>
        <span class="input_sty">{{value1}}</span>
    </div>
</template>

<script>
  export default {
    name:"InputRead",
    data(){
        return{
            value1:this.value
        }
    },
    props:{
        value:[String,Number,Object],
        name: {type: String,},
    },
    watch:{
        value:{
            handler(newValue, oldValue) {
                if(typeof(newValue) == 'string'||typeof(newValue) == 'number'){
                    this.value1 = newValue;
                }else{
                    this.value1 = newValue.FullName;
                }
            },
            deep: true,
            immediate:true
        }
    },
  }
</script>

<style lang="less">
    .InputRead{
        width: 100%;
        height: 30px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        -webkit-box-align:center;
        box-align:center;
        color: #666;
        border-radius: 5px;
        padding: 0 5px;
        box-sizing: border-box;
        .label_name{
            height: 100%;
            line-height: 30px;
            font-size: 12px;
            color: inherit;
            font-weight: bold;
        }
        .input_sty{
            position:relative;
            -webkit-box-flex: 1; 
            box-flex: 1;
            display: block;
            height: 100%;
            line-height: 30px;
            margin-left: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Input/InputRead/InputRead.vue